/**
 * Created by Jew on 18-Aug-2017.
 * Updated by Tun - Thanyanit Jongjitragan on 30-Sep-2022.
 */
import {
   ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef,
   ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Meta, DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { IdexService, Error } from 'app/idex.service';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MomentPipe } from 'app/shared/moment.pipe';
import { DeleteCommentComponent } from '../delete-comment/delete-comment.component';
import { WaitForImportComponent } from '../google-drive/wait-for-import.component';
import { OneDrive } from '../onedrive/onedrive.service';
import { Mimetype } from 'app/shared/mimetype';
import { TranslateService } from '@ngx-translate/core';
import { DocTypeComponent } from '../../shared/doctype.component';
import { Toast } from '../../shared/toast/toast';
import { DownloadFolderComponent } from '../download-folder/download-folder.component';
import { SharingComponent } from '../sharing/sharing.component';
import { Path } from '../../shared/path';
import { AppComponent } from '../../app.component';
import { UploadFilesComponent } from '../upload-files/upload-files.component';
import { DocListComponent } from '../doclist/doclist.component';
import { UploadService } from '../upload.service';
import { Subscription } from 'rxjs';
import { UploadProgressComponent } from '../upload-progress/upload-progress.component';
import { FileUploader } from '../file-uploader';
import { CreateFolderComponent } from '../create-folder/create-folder.component';
import { CreateOneDriveComponent } from '../onedrive/create-onedrive.component';
import { CreateGoogleDriveComponent } from '../google-drive/create-google-drive.component';
import { DownloadZipComponent } from '../download-zip/download-zip.component';
import { ConfirmDeleteComponent } from '../confirm-delete/confirm-delete.component';
import { AnnotationControllerService } from '../annotation-controller/annotation-controller.service';
import { DocumentData } from '../annotation-controller/document-data.type';
import {SocialLogin} from "../../account/social-login";

declare const $: any;
declare const moment: any;
declare const facebook: string;
declare const google: string;
declare const isPdfTron: boolean;

@Component({
   selector: 'app-view-share',
   templateUrl: './view-share.component.html',
   styleUrls: ['../viewer/viewer.component.css']
})
export class ViewShareComponent implements OnInit, OnDestroy {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';

   // Seriously, if we make these a class,
   // our code readability and code suggestion gonna be a lot better!
   protected doc: any;
   protected documentData: DocumentData; // used for initialize PDFTron WebViewer

   form: any;
   selectedValue: any;
   share_id: any;
   comment: any;
   types: any[];
   settype = false;
   canNotPreview: boolean;
   text: string;
   mail: any;
   imageUrl: string;
   svg: SafeHtml;
   pdfUrl: SafeResourceUrl;
   videoUrl: string;
   audioUrl: string;
   post = 'ส่ง';
   lastModified: any;
   loaded = false;
   error: Error;
   downloads = false;
   dataShare: any;
   user: any;
   action_status = true;
   saveText = 'Save';

   path: any;
   pathTemp: any;
   isBusiness: boolean;
   showSideInfo = false;
   show: boolean;
   password: string;
   private token: string;
   verify = true;
   readonly size = 5242880;
   owner: string;

   notesPanelVisibilitySubscription: Subscription;

   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   @ViewChild('info') info: ElementRef;
   @ViewChild('selectType') selectType: any;
   @ViewChild('form1', { read: ViewContainerRef }) form1: ViewContainerRef;
   @ViewChild('form2', { read: ViewContainerRef }) form2: ViewContainerRef;
   private spacer = 20 + 38; // docList padding 20px + .content-container padding-bottom 38px

   fb_app_id = facebook;
   isPdfTron = isPdfTron;

   canPrint: boolean;
   cancel = false;

   shareType: 'Public' | 'Anyone' | 'Private';

   // List document of folder

   private subscriber: Subscription;
   @ViewChild(DocListComponent) docList: DocListComponent;
   @ViewChild('fileUpload') fileUpload: any;
   @ViewChild('progress') progress: UploadProgressComponent;

   content: any;
   object_file: any;
   selectedItems: any[] = [];

   private page = 1;
   private pageSize = 50;
   private progress_dlg: MatDialogRef<UploadFilesComponent>;
   sharer: any;
   typeIsFolder = false;
   isFolder = false;
   public: boolean;
   isShowBackButton = false;
   permissionLevel = 0;
   isDownload = false;
   public canDrag = false;
   supportFolderUpload: boolean;
   paths: any[];
   shareDocId: string;
   access_token: string;

   constructor(private route: ActivatedRoute, private router: Router,
      public service: IdexService, private onedrive: OneDrive,
      private sanitizer: DomSanitizer, public dialog: MatDialog,
      private resolver: ComponentFactoryResolver,
      private changeDetector: ChangeDetectorRef,
      private translate: TranslateService, private toast: Toast,
      private meta: Meta, private app: AppComponent,
      private upload: UploadService, public uploader: FileUploader,
      private renderer: Renderer2,
      private annoService: AnnotationControllerService,
      private socialLogin: SocialLogin) {
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
      this.translate.get('save').subscribe(s => {
         this.saveText = s;
      });
   }

   ngOnInit() {
      this.subscriber = this.route.url.subscribe(url => {
         this.path = decodeURIComponent(url.join('/'));

         if (!this.service.shareDocId) {
            this.service.shareId = sessionStorage.getItem('shareId');
            this.service.shareDocId = sessionStorage.getItem('shareDocId');
            this.service.isDownload = sessionStorage.getItem('isDownload') === 'true';
            this.service.permissionLevel = parseInt(sessionStorage.getItem('permissionLevel'), 10);

            sessionStorage.removeItem('shareId');
            sessionStorage.removeItem('shareDocId');
            sessionStorage.removeItem('isDownload');
            sessionStorage.removeItem('permissionLevel');
         }

         sessionStorage.setItem('shared', 'true');
         this.onLoadDoc();
      });

      this.notesPanelVisibilitySubscription = this.annoService.getNotesPanelVisibilityStatus().subscribe((isNotesPanelOpen) => {
         // If NotesPanel is open while side panel is already open, hide side panel
         if (isNotesPanelOpen && this.info?.nativeElement.className.indexOf('slide-right') === -1) {
            this.closeSidePanel();
         }
      });
   }

   ngOnDestroy() {
      this.notesPanelVisibilitySubscription?.unsubscribe();
   }

   onLoadDoc() {
      this.user = this.service.user;
      this.token = this.user ? this.user.token : '';
      this.route.params.forEach((params: Params) => {
         this.share_id = params['shareId'];
         const input = document.createElement('input');
         this.supportFolderUpload = ('webkitdirectory' in input
            || 'mozdirectory' in input
            || 'odirectory' in input
            || 'msdirectory' in input
            || 'directory' in input);
         this.checkDevice('idex://share-public?key=' + this.share_id, this.share_id);
      });

      window.addEventListener('message', () => {
         if (this.onedrive.action === 'share') {
            if (this.action_status) {
               this.openWith();
               this.action_status = false;
            }
         }
      });
   }

   @HostListener('window:beforeunload', ['$event'])
   unload($event: any) {
      sessionStorage.setItem('shareId', this.service.shareId);
      sessionStorage.setItem('shareDocId', this.service.shareDocId);
      sessionStorage.setItem('isDownload', this.service.isDownload.toString());
      sessionStorage.setItem('permissionLevel', this.service.permissionLevel.toString());
      sessionStorage.removeItem('verify');
   }

   navigate(path: string) {
      sessionStorage.setItem('verify', this.verify.toString());
      if (path) {
         const url = Path.combine('/share', this.share_id, path);
         this.router.navigate([url]);
      } else {
         this.router.navigate(['/share', this.share_id]);
      }
   }

   getSharePublic() {
      this.service.sharePublic(this.share_id)
         .subscribe(data => {
            this.doc = data.item;
            this.doc.watermark = data.watermark
            this.shareType = data.type;
            this.owner = data.sharer;
            // Share - Public
            if (this.shareType === 'Public') {
               this.router.navigate(['/share-public', this.share_id]);
            }
            // Share - Anyone or Private
            else {
               if (!this.user) {
                  this.app.user = undefined;
                  this.service.setUser();

                  const url = window.location.pathname.replace('/idex', '');
                  const shareId = url.replace('/share/', '').split('/')[0];
                  const share_url = Path.combine('/login', encodeURIComponent('share/'), encodeURIComponent(shareId));
                  this.router.navigate([share_url]);
               }

               this.permissionLevel = data.permissionLevel;
               this.isDownload = data.download;
               this.dataShare = data;
               this.downloads = data.download;
               sessionStorage.setItem('dl', this.downloads.toString());
               this.settype = !!this.doc.properties;
               this.show = Mimetype.canEdit(this.doc);
               this.canPrint = Mimetype.canPrint(this.doc);

               if (sessionStorage.getItem('verify')
                  && sessionStorage.getItem('verify') === 'true') {
                  this.verify = true;
               } else {
                  this.verify = data.password ? false : true;
               }

               if (data.access !== 'Comment') {
                  this.comment = data.comments;
               } else {
                  this.getShareComment();
               }

               if (data.item.isFolder) {
                  this.isFolder = true;
                  this.canNotPreview = false;
                  this.public = data.type === 'Public';

                  this.pathTemp = this.doc.name + '/' + this.path;
                  this.sharer = this.service.user.email;
                  this.createBreadcrumb();

                  localStorage.setItem('shareId', this.doc.id);
                  sessionStorage.setItem('shareId', this.doc.id);
                  if (this.verify) {
                     this.showDocument();
                  }
                  this.upload.getLimitSize();
               } else {
                  this.initDocument();
               }

               if (!this.settype && data.type !== 'Public') {
                  this.service.getTypes().subscribe(dataType => {
                     this.types = dataType;
                     this.settype = false;
                  });
               } else {
                  setTimeout(() => {
                     if (this.doc.properties) {
                        this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1,
                           this.form1, this.doc.properties);
                     }
                     this.updateContainerHeight();
                  }, 200);
               }

               // Share - Private
               if (data.type === 'Private') {
                  if (localStorage.getItem('url')) {
                     this.isShowBackButton = true;
                  }
                  for (const permission of this.dataShare.permissions) {
                     if (permission.id === this.user.email) {
                        this.dataShare.access = permission.access;
                        this.dataShare.allowShare = permission.allowShare;
                     }
                  }
               }
               // Share - Anyone
               else {
                  this.isShowBackButton = false;
               }

               this.updateMeta();
            }
         }, error => {
            this.error = error;
         });
   }

   private createBreadcrumb(): void {
      const files = this.doc.name;
      if (this.path.length === 0) {
         this.paths = [{ name: files }];
         return;
      }

      const paths = [];
      paths.push({ name: files, path: '/' });

      let fullPath = '';
      const array = this.path.match(/[^/]+/g);
      for (let i = 0; i < array.length; i++) {
         if (i === array.length - 1) {
            fullPath = null;
         } else {
            if (fullPath.length > 0) {
               fullPath += '/';
            }
            fullPath += array[i];
         }
         paths.push({ name: array[i], path: fullPath });
      }
      this.paths = paths;
   }

   canEdit(item: any): boolean {
      return Mimetype.canEdit(item);
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }

   getShareComment() {
      this.service.shareComment(this.share_id)
         .subscribe(data => {
            this.comment = data.items;
         });
   }

   initDocument(): void {
      const mimeType = this.doc.mimeType;

      if (mimeType === 'application/pdf'
         || (['application/vnd.oasis.opendocument.text',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/msword',
            'application/vnd.ms-excel',
            'application/vnd.ms-powerpoint',
            'image/tiff',
         ].includes(mimeType) && this.doc.size <= this.size)) {
         const file = encodeURIComponent(this.service.url + '/share-public/' + this.share_id + '/content?token=' + this.token + '&' + Date.now());
         // URL used by PDFTron or PDFJS to render document
         this.pdfUrl = (isPdfTron) ? file : this.sanitizer.bypassSecurityTrustResourceUrl('assets/pdfjs/web/viewer.html?file=' + file);
         const docUrl = this.service.url + '/content?id=' + this.doc.id + '&token=' + this.token + '&isPdfTron=' + isPdfTron + '&' + Date.now();
         this.extracted(docUrl);

         // Office files stored in zDOX are converted to PDF, but the file name/extension may not change to .pdf
         this.documentData.fileFormat = "pdf";
      }
      else if (mimeType === 'image/jpeg' || mimeType === 'image/png') {
         this.imageUrl = this.service.url + '/share-public/' + this.share_id +
         '/content?token=' + this.token + '&' + Date.now();
         this.extracted(this.imageUrl);
      }
      else if (mimeType === 'image/svg+xml') {
         const svgUrl = '/share-public/' + this.share_id + '/content?token=' + this.token;
         this.extracted(svgUrl);
         this.service.get(svgUrl, { responseType: 'text' }).subscribe(data => {
            this.svg = this.sanitizer.bypassSecurityTrustHtml(data);
            this.loaded = true;
         });
      }
      else if (mimeType.indexOf('video/') === 0 && mimeType !== 'video/mpeg' && mimeType !== 'video/avi'
         && mimeType !== 'video/msvideo' && mimeType !== 'video/x-msvideo') {
         this.videoUrl = 'typeVideo';
         this.service.toDataURL(this.service.url + '/share-public/' + this.share_id +
            '/content?' + Date.now(), function (dataUrl) {
               document.getElementById('fileVideo').setAttribute('src', dataUrl);
            });
      }
      else if (mimeType.indexOf('audio/') === 0) {
         this.audioUrl = 'typeAudio';
         this.service.toDataURL(this.service.url + '/share-public/' + this.share_id +
            '/content?' + Date.now(), function (dataUrl) {
               document.getElementById('fileAudio').setAttribute('src', dataUrl);
            });
      }
      else if (mimeType.indexOf('text/') === 0 || mimeType === 'application/xml') {
         const url = '/share-public/' + this.share_id + '/content';
         this.service.get(url, { responseType: 'text' }).subscribe(data => {
            this.text = data;
            this.loaded = true;
         });
      }
      else if (mimeType === 'message/rfc822') {
         const url = '/share-public/' + this.share_id + '/content';
         this.service.get(url).subscribe((data: any) => {
            data.from = this.formatAddress(data.from);
            data.to = this.formatAddress(data.to);
            if (data.cc) {
               data.cc = this.formatAddress(data.cc);
            }
            if (data.html) {
               data.html = this.sanitizer.bypassSecurityTrustResourceUrl('data:text/html,' + data.html);
            }
            this.mail = data;
            this.loaded = true;
         });
      }
      else {
         this.canNotPreview = true;
         this.loaded = true;
      }
      const fmt = new MomentPipe();
      this.lastModified = { when: fmt.transform(this.doc.modified) };
   }

   /**
    * Extract properties from `doc` to `documentData`
    *
    * Straight copy from `viewer.component.ts`
    * No idea why this method is `private`.
    * I suggest we refactor this part.
    *
    * @param url URL of the document to show via PDFTron
    */
   private extracted(url: string) {
      this.documentData = {
         url: url + '&includeWatermark=false',
         fileName: encodeURIComponent(this.doc.name),
         type: this.doc.type,
         mimeType: this.doc.mimeType,
         docId: this.doc.id,
         path: this.doc.path,
         statusStartFlow: this.doc.startFlow,
         statusDocument: this.doc.statusDocument,
         isPermissions: this.doc.permissions,
         allowDownloadAndPrint: this.downloads,
         watermark: this.doc.watermark,
         actionType: "dms",
         owner: this.owner,
      };
      this.loaded = true; // Don't know what this is
      this.renderer.addClass(this.info.nativeElement, 'slide-right'); // Don't know what this is
   }

   private formatAddress(array: any[]): string {
      let s = '';
      array.forEach(addr => {
         if (s.length > 0) {
            s += ', ';
         }
         if (addr.name) {
            s += '<b>' + addr.name + '</b> ';
         }
         s += '&lt;' + addr.address + '&gt;';
      });
      return s;
   }

   frameLoaded(iframe: any) {
      const that = this;
      const document = iframe.contentWindow.document;
      document.addEventListener('pagesinit', function () {
         that.loaded = true;
         that.cancel = false;
         that.changeDetector.detectChanges();
      });

      setTimeout(() => {
         if (!this.loaded) {
            this.loaded = true;
            this.cancel = true;
         }
      }, 20000);
   }

   viewAttatchment(a: any) {
      const url = this.service.url + '/attachment?id=' + this.doc.id + '&aid=' + a.id + '&token=' + this.token;
      window.open(url, a.id || this.doc.id);
   }

   download() {
      if (this.doc.isFolder) {
         if (this.path === '') {
            this.service.get('/share-public/' + this.share_id + '/download' + '?token=' + this.token)
               .subscribe(data => {
                  this.dialog.open(DownloadFolderComponent, {
                     disableClose: true,
                     data: {
                        id: data.nodeRef,
                        name: this.doc.name,
                        service: this.service
                     }
                  });
               });
         } else {
            const arrDocName = this.path.split('/');
            const docName = arrDocName[arrDocName.length - 1];
            this.dialog.open(DownloadFolderComponent, {
               disableClose: true,
               data: {
                  id: this.service.shareDocId,
                  name: docName,
                  service: this.service
               }
            });
         }
      } else {
         location.href = this.service.url + '/share-public/' + this.share_id + '/download' + '?token=' + this.token;
      }
   }

   linkify(s: string): string {
      if (!s) {
         return s;
      }
      const urlPattern = /\b(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
      // www. sans http:// or https://
      const pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      // Email addresses *** here I've changed the expression ***
      const emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
      return s.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
         .replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
         .replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>');
   }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   saveDescription(e: Event): void {
      const input = <HTMLTextAreaElement>e.target;
      if (input.value !== this.doc.description) {
         // TODO: call PUT /description { id: this.doc.id, description: input.value }
         this.doc.description = input.value;
         this.service.share_updateDescription(input.value, this.share_id)
            .subscribe(
               data => {
                  // This is intentional.
               },
               error => {
                  this.error = error;
               });
      }
   }

   postComment(button: MatButton, input: any): void {
      const text = input.value.trim();
      if (text.length === 0) {
         input.focus();
         return;
      }
      button.disabled = true;
      this.translate.get('sending').subscribe(s => {
         this.post = s;
      });
      this.service.postShareComment(this.share_id, text).subscribe(() => {
         input.value = '';
         this.translate.get('sended').subscribe(s => {
            this.post = s;
         });
         this.getShareComment();
         setTimeout(() => {
            button.disabled = false;
            this.translate.get('send').subscribe(s => {
               this.post = s;
            });
         }, 3000);
      },
         error => {
            button.disabled = false;
            this.translate.get('send').subscribe(s => {
               this.post = s;
            });
         });
   }

   delComment(item: any): void {
      const dialogRef = this.dialog.open(DeleteCommentComponent, {
         disableClose: true,
         data: { service: this.service, item: item }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.comment.indexOf(item);
            if (i !== -1) {
               this.comment.splice(i, 1);
            }
         }
      });
   }

   private updateContainerHeight() {
      setTimeout(() => {
         const height = $('.info-body:visible').outerHeight(true) + $('.info-title').outerHeight(true);
         $('.list-container').css('min-height', height + 'px');
         this.adjustInfoPosition();
      }, 100);
   }

   private adjustInfoPosition() {
      const info = $('.info-body:visible');
      if (info.length === 0) {
         return;
      }

      const title = $('.info-title');
      const infoTop = title.position().top + title.outerHeight(true);
      const top = infoTop + 'px';
      if (window.scrollY > 0) {
         // TODO: detect scroll direction and use to calc position instead of window.scrollY
         const height = info.outerHeight(true);
         if (window.innerHeight - infoTop - height < 0) {
            const x = window.innerHeight - this.spacer;
            let y = infoTop - window.scrollY;
            if (y + height < x) {
               y = x - height;
            }
            info.css({ top: y + 'px' });
         } else {
            info.css({ top: top });
         }
      } else {
         info.css({ top: top });
      }
   }

   loadForm(name: string) {
      this.form = undefined;
      this.service.getType(name).subscribe(data => {
         this.form = data;
         this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
         this.updateContainerHeight();
      });
   }

   private getProperties(form: any[]) {
      const error = function (e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (const property of form) {
         const f = property;
         const e = $('#' + f.name.replace(':', '_'));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + ' is required');
         }
         if (f.constraints && value) {
            if (f.constraints.minLength && value.length < f.constraints.minLength) {
               return error(e, 'Minimum length of ' + f.label + ' is ' + f.constraints.minLength + ' characters');
            }
            if (f.constraints.maxLength && value.length > f.constraints.maxLength) {
               return error(e, 'Maximum length of ' + f.label + ' is ' + f.constraints.maxLength + ' characters');
            }
            if (f.constraints.minValue !== undefined && value < f.constraints.minValue) {
               return error(e, 'Minimum value of ' + f.label + ' is ' + f.constraints.minValue);
            }
            if (f.constraints.maxValue !== undefined && value > f.constraints.maxValue) {
               return error(e, 'Maximum value of ' + f.label + ' is ' + f.constraints.maxValue);
            }
            if (f.constraints.expression && !new RegExp(f.constraints.expression).test(value)) {
               return error(e, 'Value of ' + f.label + ' did not match the pattern');
            }
         }
         properties[f.name] = value;
      }
      return properties;
   }

   saveType(button: any, type: any) {
      const data = { type: type, properties: this.getProperties(this.form) };
      if (!data.properties) {
         return;
      }
      button.disabled = true;
      this.translate.get('saving').subscribe(s => {
         this.saveText = s;
      });
      this.service.share_setType(this.share_id, data).subscribe(value => {
         this.doc.typeName = this.selectType.selected.viewValue;
         this.doc.type = type;
         this.doc.properties = value;
         this.settype = true;
         this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, value);
         this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, []);
         this.translate.get('saved').subscribe(s => {
            this.saveText = s;
         });
         setTimeout(() => {
            button.disabled = false;
            this.translate.get('save').subscribe(s => {
               this.saveText = s;
            });
         }, 5000);
      });
   }

   saveProperties(button: MatButton) {
      const properties = this.getProperties(this.doc.properties);
      if (!properties) {
         return;
      }
      button.disabled = true;
      this.translate.get('saving').subscribe(s => {
         this.saveText = s;
      });
      this.service.share_setMetadata(this.share_id, properties).subscribe(data => {
         this.doc.properties = data;
         this.translate.get('saved').subscribe(s => {
            this.saveText = s;
         });
         setTimeout(() => {
            button.disabled = false;
            this.translate.get('save').subscribe(s => {
               this.saveText = s;
            });
         }, 5000);
      });
   }

   getExpired(exp: any) {
      return moment(exp).format('dddd DD MMMM YYYY hh:mm:ss');
   }

   openWith() {
      if (window.localStorage.getItem('access_token') === null) {
         this.onedrive.signIn('share');
      } else {
         const dialogRef = this.dialog.open(WaitForImportComponent, { disableClose: true, data: this });
         const waiting = dialogRef.componentInstance;
         waiting.path = this.path;
         this.translate.get('onedrive.open').subscribe(s => {
            waiting.message = s;
         });
         this.service.share_openOnedrive(this.share_id, window.localStorage.getItem('access_token'))
            .subscribe(data => {
               window.open(data.webUrl, '_blank');
               waiting.progress = false;
               waiting.status = 'share';
               waiting.id = data.id;
               waiting.doc_id = this.share_id;
               waiting.isBusiness = this.isBusiness;
               this.translate.get('onedrive.save').subscribe(s => {
                  waiting.message = s;
               });
               this.translate.get('onedrive.saveText').subscribe(s => {
                  waiting.saveText = s;
               });
               waiting.update();
            }, error2 => {
               if (error2.status === 401 || (error2.status === 500 && error2.message === 'Stream closed')) {
                  dialogRef.close();
                  localStorage.removeItem('access_token');
                  this.onedrive.signIn('file');
               } else {
                  dialogRef.close();
                  this.toast.error(error2.message);
               }
            });
      }
   }

   openWithGoogle() {
      let mimeType;
      if (this.doc.openWithGoogle === 'Google Sheets') {
         mimeType = 'spreadsheets';
      } else {
         mimeType = 'document';
      }
      const next = () => {
         const dialogRef = this.dialog.open(WaitForImportComponent, { disableClose: true, data: this });
         const waiting = dialogRef.componentInstance;
         waiting.path = this.path;
         this.translate.get('googleDoc.open').subscribe(s => {
            waiting.message = s;
         });
         this.service.openwith_google(this.doc.id, this.access_token )
            .subscribe(data => {
               window.open('https://docs.google.com/' + mimeType + '/d/' + data.id + '/edit');
               waiting.progress = false;
               waiting.status = 'share-drive';
               waiting.id = data.id;
               waiting.doc_id = this.share_id;
               waiting.name = this.doc.name;
               waiting.access_token = this.access_token ;
               this.translate.get('onedrive.save').subscribe(s => {
                  waiting.message = s;
               });
               this.translate.get('onedrive.saveText').subscribe(s => {
                  waiting.saveText = s;
               });
               waiting.update();
               waiting.isBusiness = this.isBusiness;
            });
      };
      if (!sessionStorage.getItem('access_token_google')) {
         this.socialLogin.withGoogle().subscribe(result => {
            this.access_token = sessionStorage.getItem('access_token_google') as string;
            next();
         });
      } else {
         this.access_token = sessionStorage.getItem('access_token_google') as string;
         next();
      }
   }

   back() {
      this.router.navigate(['/']);
   }

   editComment(item: any) {
      item.editing = true;
      setTimeout(() => {
         $('#edit-' + item.id).focus();
      }, 200);
   }

   saveComment(item: any, input: any) {
      if (input.value.trim().length === 0) {
         return;
      }
      this.service.put('/comments/' + item.id + '/' + this.doc.id, { content: encodeURIComponent(input.value) })
         .subscribe(res => {
            item.editing = false;
            item.content = input.value;
         });
   }

   verifyPassword(input: any) {
      if (input.value.length === 0) {
         input.focus();
         return;
      }
      this.service.post('share-public/' + this.share_id + '/verify', { password: input.value })
         .subscribe(res => {
            this.setVerify();
         });
   }

   setVerify() {
      this.verify = true;
      setTimeout(() => {
         if (this.dataShare.item.isFolder) {
            this.showDocument();
         }

         if (this.doc.properties) {
            this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, this.doc.properties);
         }
         this.updateContainerHeight();
      }, 200);
   }

   share() {
      this.dialog.open(SharingComponent, {
         disableClose: true,
         data: {
            id: this.doc.id,
            name: this.doc.name,
            service: this.service,
            toast: this.toast,
            role: this.service.role,
            item: this.doc
         }
      });
   }

   back_left() {
      if (this.service.user != null) {
         this.router.navigate([localStorage.getItem('url')]);
         localStorage.removeItem('url');
      } else {
         this.router.navigate(['/login']);
      }
   }

   toggle(): void {
      if (!this.info) return;

      // If side panel is currently open
      if (this.info.nativeElement.className.indexOf('slide-right') === -1) {
         // Hide side panel
         this.closeSidePanel();
      } else {
         // Show side panel
         this.openSidePanel();
      }
   }
   closeSidePanel(): void {
      this.renderer.addClass(this.info.nativeElement, 'slide-right');
   }
   openSidePanel(): void {
      //| When DMS side panel is open,
      //| if PDFTron's NotesPanel is also open, close it.
      this.annoService.instance?.UI.closeElements(['notesPanel']);
      this.annoService.instance?.Core.documentViewer.getAnnotationManager().deselectAllAnnotations();

      this.renderer.removeClass(this.info.nativeElement, 'slide-right');
   }

   printFrame() {
      const iframe = window.frames['printf'];
      iframe.focus();
      iframe.print();
   }

   checkDevice(path, shareId) {
      if (this.docList) {
         this.docList.items = undefined;
      }

      this.getSharePublic();
   }

   updateMeta() {
      this.meta.addTag({ property: 'og:url', content: window.location.toString() });
      this.meta.addTag({ property: 'og:type', content: 'website' });
      this.meta.updateTag({ property: 'og:title', content: this.doc.name });
      this.meta.addTag({ property: 'og:site_name', content: 'zDOX' });
      this.meta.addTag({
         property: 'og:image',
         content: 'https://www.getinvoice.net/wp-content/uploads/2018/06/webpage_idex.png'
      });
      this.meta.updateTag({ property: 'og:description', content: this.doc.description ? this.doc.description : '' });
      this.meta.addTag({ property: 'fb:app_id', content: this.fb_app_id });
      this.meta.addTag({ name: 'twitter:card', content: 'summary' });
      this.meta.addTag({ name: 'twitter:title', content: 'Shared From zDOX' });
      this.meta.addTag({ name: 'twitter:description', content: this.doc.description ? this.doc.description : '' });
      this.meta.addTag({
         name: 'twitter:image',
         content: 'https://www.getinvoice.net/wp-content/uploads/2018/06/webpage_idex.png'
      });
   }

   showDocument() {
      this.selectedItems = [];
      this.page = 1;
      this.service.listShareDocuments(this.pathTemp, this.page, this.pageSize, this.sharer,
         this.doc.id, this.shareType, this.isDownload, this.permissionLevel)
         .subscribe(
            data => {
               if (this.docList) {
                  this.docList.permissionLevel = this.permissionLevel;
                  this.docList.setItems(data.items, data.hasMore);
                  document.body.scrollTop = 0;
               }
               this.service.shareDocId = data.metadata.parent.nodeRef.replace('workspace://SpacesStore/', '');
               this.loaded = true;
            });
   }

   onLoadMore() {
      const sharedId = this.doc.id;
      this.service.listShareDocuments(this.pathTemp, this.page + 1, this.pageSize, this.sharer,
         sharedId, this.shareType, false, 0)
         .subscribe(
            data => {
               this.docList.addItems(data.items, data.hasMore);
               if (data.hasMore) { this.page++; }
               this.service.shareDocId = data.metadata.parent.nodeRef.replace('workspace://SpacesStore/', '');
            });
   }

   onClickItem(item: any) {
      localStorage.setItem('sharer', item.modifier.id);
      let path = location.pathname;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }

      if (item.shareId) {
         this.service.shareId = item.shareId;
      } else {
         if (path.indexOf('/share/') === 0) {
            this.service.shareId = path.replace('/share/', '').split('/')[0];
         }
      }

      this.service.shareDocId = item.id;
      this.service.isDownload = item.isDownload;
      this.service.permissionLevel = item.permissionLevel;

      sessionStorage.setItem('verify', this.verify.toString());
      localStorage.setItem('url', Path.combine(path));
      this.redirect(item);
   }

   redirect(item: any) {
      if (item.isFolder) {
         this.service.shareType = this.shareType;
         const url = Path.combine('/share', this.share_id, encodeURIComponent(this.path), encodeURIComponent(item.name));
         this.router.navigate([url]);
      } else {
         this.router.navigate(['/file', item.id]);
      }
   }

   onSelectFiles(input: any) {
      if (input.files.length === 0) {
         return;
      }

      const files = input.files;
      this.object_file = files;
      this.progress_dlg = this.dialog.open(UploadFilesComponent, {
         disableClose: true,
         data: this,
         hasBackdrop: false
      });
      this.progress_dlg.updatePosition({ bottom: '10px', right: '10px' });
      this.progress_dlg.componentInstance.object_file = this.object_file;
      this.app.uploading = true;
      for (let i = 0; i < files.length; i++) {
         this.upload.getKeyUpload()
            .subscribe(data => {
               this.object_file[i].key = data.key;
               this.object_file[i].cancel = false;
               this.object_file[i].mimeType = this.object_file[i].type;
               this.upload.uploadFile(files[i], this.pathTemp, this, data.key, i, files.length);
            }, error => { this.progress_dlg.close(); });
      }
   }

   onDragOver(event: DragEvent) {
      if (this.permissionLevel < 2) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.effectAllowed = 'none';
         event.dataTransfer.dropEffect = 'none';
      } else {
         const data = event.dataTransfer;
         let hasFiles = false;
         if (data.items) {
            for (let i = 0; i < data.items.length; i++) {
               if (data.items[i].kind === 'file') {
                  hasFiles = true;
                  break;
               }
            }
         } else if (data.files && data.files.length > 0) {
            hasFiles = data.files && data.files.length > 0;
         }

         if (hasFiles) {
            event.preventDefault();
            event.stopPropagation();
            event.dataTransfer.dropEffect = 'copy';
            this.renderer.addClass(this.docList.nativeElement, 'drag-over');
         }
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');

      this.uploader.process(event.dataTransfer, this.upload.limitSize, this.pathTemp, null, this.uploadCallback, this.doc.id);
   }

   onDragLeave() {
      this.renderer.removeClass(this.docList.nativeElement, 'drag-over');
   }

   selectedDownload() {
      const listIds = [];
      let name = 'Archive';
      if (this.selectedItems) {
         if (this.selectedItems.length === 1) {
            name = this.selectedItems[0].name;
         }
         for (const itemSel of this.selectedItems) {
            listIds.push(itemSel.id);
         }
      }

      this.dialog.open(DownloadZipComponent, {
         disableClose: true,
         data: {
            idList: listIds,
            name: name,
            service: this.service
         }
      });
   }

   confirmDelete(): void {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: {
            service: this.service, listItem: this.selectedItems.sort((a: any, b: any) => a.name < b.name ? -1 : 1),
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate
         }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
         }
      });
   }

   newFolder() {
      this.canDrag = false;
      this.shareDocId = this.doc.id;
      const rootPath = this.path;
      this.path = this.pathTemp;
      const dialogRef = this.dialog.open(CreateFolderComponent, {
         disableClose: true,
         data: this,
      });
      dialogRef.componentInstance.toast = this.toast;
      dialogRef.componentInstance.translate = this.translate;
      dialogRef.afterClosed().subscribe(result => {
         this.canDrag = true;
         this.path = rootPath;
      });
   }

   startOnedrive(type: any) {
      this.canDrag = false;
      const onedrive = this.dialog.open(CreateOneDriveComponent, {
         disableClose: true,
         data: this
      });
      onedrive.componentInstance.doctype = type;
      onedrive.componentInstance.path = this.pathTemp;
      onedrive.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   startGoogle(type: any) {
      this.canDrag = false;
      const createGoogle = this.dialog.open(CreateGoogleDriveComponent, {
         disableClose: true,
         data: {
            filesComponent: this,
            path: '', // this.pathTemp,
            type: type
         }
      });
      createGoogle.componentInstance.isBusiness = false;
      createGoogle.afterClosed().subscribe(result => {
         this.canDrag = true;
      });
   }

   uploadSelected(myFiles: any): void {
      this.uploader.uploadFolder(myFiles, this.upload.limitSize, this.pathTemp, null, this.uploadCallback, null, this.doc.id);
   }

   uploadFolder(files: FileList): void {
      this.uploader.uploadFolder(files, this.upload.limitSize, this.pathTemp, null, this.uploadCallback, null, this.doc.id);
   }

   uploadNewVersion(event: any): void {
      this.uploader.uploadFolder(event.file, this.upload.limitSize, this.pathTemp, null, this.uploadCallback, event.item.id);
   }

   private uploadCallback = {
      init: (files) => {
         this.progress.init(files);
      },
      quotaExceed: (i: number, size: number, error: string) => {
         this.progress.quotaExceed(i, size, error);
      },
      limitExceed: (i: number, size: number) => {
         this.progress.limitExceed(i, size, this.upload.limit);
      },
      progress: (i: number, progress: number) => {
         this.progress.update(i, progress);
      },
      cancelUpload: (i: number, error: string) => {
         this.progress.cancelUpload(i, error);
      },
      complete: () => {
         this.progress.complete();
         setTimeout(() => {
            this.progress.hide();
            this.showDocument();
         }, this.progress.calcDelay());
      }

   };
}
